import type {
    getGetFrameInfos,
    getGetFrameInfosV2,
    getAddOnHighMemoryEventEventHandler,
    getRemoveOnHighMemoryEventEventHandler,
    getAddOnIframeCreatedEventHandler,
    getRemoveOnIframeCreatedEventHandler,
    getAddOnIframeDestroyedEventHandler,
    getRemoveOnIframeDestroyedEventHandler,
    getAddOnHighMemoryEventV2EventHandler,
    getRemoveOnHighMemoryEventV2EventHandler,
    getAddOnIframeCreatedV2EventHandler,
    getRemoveOnIframeCreatedV2EventHandler,
    getAddOnIframeDestroyedV2EventHandler,
    getRemoveOnIframeDestroyedV2EventHandler,
    getNotifyIframeStateChange,
} from '../lazyIndex';
import { LazyAction } from 'owa-bundling-light';
import { lazyModule } from '../lazyFunctions';

export const lazyGetGetFrameInfos: LazyAction<typeof getGetFrameInfos, typeof lazyModule> =
    new LazyAction(lazyModule, m => m.getGetFrameInfos);

export const lazyGetGetFrameInfosV2: LazyAction<typeof getGetFrameInfosV2, typeof lazyModule> =
    new LazyAction(lazyModule, m => m.getGetFrameInfosV2);

export const lazyGetAddOnHighMemoryEventEventHandler: LazyAction<
    typeof getAddOnHighMemoryEventEventHandler,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.getAddOnHighMemoryEventEventHandler);

export const lazyGetRemoveOnHighMemoryEventEventHandler: LazyAction<
    typeof getRemoveOnHighMemoryEventEventHandler,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.getRemoveOnHighMemoryEventEventHandler);

export const lazyGetAddOnIframeCreatedEventHandler: LazyAction<
    typeof getAddOnIframeCreatedEventHandler,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.getAddOnIframeCreatedEventHandler);

export const lazyGetRemoveOnIframeCreatedEventHandler: LazyAction<
    typeof getRemoveOnIframeCreatedEventHandler,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.getRemoveOnIframeCreatedEventHandler);

export const lazyGetAddOnIframeDestroyedEventHandler: LazyAction<
    typeof getAddOnIframeDestroyedEventHandler,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.getAddOnIframeDestroyedEventHandler);

export const lazyGetRemoveOnIframeDestroyedEventHandler: LazyAction<
    typeof getRemoveOnIframeDestroyedEventHandler,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.getRemoveOnIframeDestroyedEventHandler);

export const lazyGetAddOnHighMemoryEventV2EventHandler: LazyAction<
    typeof getAddOnHighMemoryEventV2EventHandler,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.getAddOnHighMemoryEventV2EventHandler);

export const lazyGetRemoveOnHighMemoryEventV2EventHandler: LazyAction<
    typeof getRemoveOnHighMemoryEventV2EventHandler,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.getRemoveOnHighMemoryEventV2EventHandler);

export const lazyGetAddOnIframeCreatedV2EventHandler: LazyAction<
    typeof getAddOnIframeCreatedV2EventHandler,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.getAddOnIframeCreatedV2EventHandler);

export const lazyGetRemoveOnIframeCreatedV2EventHandler: LazyAction<
    typeof getRemoveOnIframeCreatedV2EventHandler,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.getRemoveOnIframeCreatedV2EventHandler);

export const lazyGetAddOnIframeDestroyedV2EventHandler: LazyAction<
    typeof getAddOnIframeDestroyedV2EventHandler,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.getAddOnIframeDestroyedV2EventHandler);

export const lazyGetRemoveOnIframeDestroyedV2EventHandler: LazyAction<
    typeof getRemoveOnIframeDestroyedV2EventHandler,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.getRemoveOnIframeDestroyedV2EventHandler);

export const lazyGetNotifyIframeStateChange: LazyAction<
    typeof getNotifyIframeStateChange,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.getNotifyIframeStateChange);
